<mat-toolbar color="primary">
  <mat-toolbar-row class="mat-elevation-z2 main-toolbar">
    <button
      class="nav-toggler"
      mat-icon-button
      (click)="onToggleSidenav()"
      *ngIf="isAuth"
    >
      <mat-icon aria-label="Menu">menu</mat-icon>
    </button>
    <a class="app-name" routerLink="/">{{ appName }}</a>

    <ul class="headerNavLinks" *ngIf="isAuth">
      <li class="headerNavLink" *ngFor="let link of headerNavLinks">
        <a
          mat-list-item
          class="nav-item"
          *ngIf="link.route"
          [routerLink]="link.route"
          [attr.disabled]="isRouteLoading"
          [ngClass]="{ disabled: isRouteLoading }"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <mat-icon aria-label="Nav">{{ link.icon }}</mat-icon>
          <span class="link-label">{{ link.title | translate }}</span>
        </a>
      </li>

      <li class="headerNavLink">
        <a mat-list-item class="nav-item pointer" (click)="goTocloud()">
          <mat-icon aria-label="Nav">cloud</mat-icon>
          <span class="link-label">Votre espace cloud</span>
        </a>
      </li>

      <li class="headerNavLink" *ngIf="canSelectClient">
        <mat-form-field>
          <mat-label>Agence</mat-label>
          <mat-select [formControl]="clientControl">
            <mat-option value="all">Toutes les agences</mat-option>
            <mat-option *ngFor="let client of clients" [value]="client">
              {{ client.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </li>
    </ul>

    <ul class="menu-links" *ngIf="isAuth">
      <li class="headerNavLink" *ngIf="isDispatcher">
        <a mat-list-item class="nav-item pointer" (click)="redirectToRuptela()">
          <mat-icon aria-label="Nav">room</mat-icon>
          <span class="link-label">Tracking des véhicules</span>
        </a>
      </li>
      <li>
        <app-notifications></app-notifications>
      </li>
      <li *ngIf="user">
        <app-user-menu [user]="user"></app-user-menu>
      </li>
    </ul>
    <ul class="version" *ngIf="!isAuth">
      <li>version {{ appVersion }}</li>
    </ul>
  </mat-toolbar-row>
</mat-toolbar>
